import { observer, React } from '@api'
import {ArrowShape} from '@modules/whiteboard'
import {getArrowPath} from './'

export const ArrowIndicator = observer<{shape: ArrowShape}>(function ArrowIndicator({shape}) {
  return <path d={getArrowPath(shape)} />
})


// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/arrow/ArrowIndicator.tsx